import { useMutation } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'
import type {
  IUserSetIsCompanyRequest,
  IUserUpdateCompanyDataRequest,
} from '~/@api/generated-api-types-user/Api'
import { getApiErrorMessage } from '~/@lib/utils/error.utils'

function useCompanyProfile() {
  // setIsCompany aj updateCompanyData = Nest /user/onboarding/*
  const client = useApiClientUser()

  const {
    mutate: setIsCompanyMutation,
    isPending: isRequestingSetIsCompany,
    error: setIsCompanyError,
  } = useMutation({
    mutationFn: async (props: IUserSetIsCompanyRequest) => {
      return await client.user
        .onboardingControllerSetIsCompany(props, { secure: true })
        .then((res) => res.data)
    },
  })

  const {
    mutate: updateCompanyDataMutation,
    isPending: isRequestingUpdateCompanyData,
    error: updateCompanyDataError,
  } = useMutation({
    mutationFn: async (data: IUserUpdateCompanyDataRequest) => {
      return await client.user.onboardingControllerUpdateCompanyData(data, {
        secure: true,
      })
    },
  })

  return {
    setIsCompanyMutation,
    isRequestingSetIsCompany,
    setIsCompanyError: getApiErrorMessage(
      setIsCompanyError,
      'Typ účtu sa nepodarilo zmeniť.'
    ),
    updateCompanyDataMutation,
    isRequestingUpdateCompanyData,
    updateCompanyDataError: getApiErrorMessage(
      updateCompanyDataError,
      'Firemné údaje sa nepodarilo uložiť.'
    ),
  }
}

export { useCompanyProfile }
